import React, { useEffect, useState } from "react";

import {
  View,
  StyleSheet,
  Text,
  Platform,
  ScrollView,
  Linking,
} from "react-native";
import ChecklistItemModel from "../../../animation/info/ChecklistItemModel";

import AppTheme from "../../../AppTheme";
import appStyles from "../../../../appStyles";
import SetupConfig from "./SetupConfig";
import { isPageWithFooter, isWeb } from "../../../../../helpers/utils";
import SettingsHelper from "../../../more/SettingsHelper";
import UsersHelper from "../../../users/UsersHelper";

export default function SetupChecklist({ controller }) {
  const [progress, setProgress] = useState(0);

  const steps = Object.values(SetupConfig);

  const isNewUser = UsersHelper.isNewUser(
    controller.state?.settings?.datetime_created,
  );

  // ------------------------------------- METHODS -------------------------------------
  useEffect(() => {
    const progressStatus = SettingsHelper.getCurrentSetupProgress(controller);

    let completedCount = 0;
    steps.forEach((item) => {
      item.isLocked = item.isLocked && isNewUser;

      // Reflection is available after user tracks time
      if (item.name === "reflection") {
        item.isLocked = !(progressStatus["track"] || progressStatus["reflection"]);
      }

      if (progressStatus[item.name]) item.isComplete = true;

      // Some items could be already marked as completed from config
      if (item.isComplete) completedCount++;
    });

    const stepsCount = steps.length;
    setProgress(Math.trunc((completedCount / stepsCount) * 100));
  }, [controller.state?.settings]);

  const goToPage = (item) => {
    if (!item.page) return;

    if (item.name == "has_scheduled_call") {
      controller.cardAction({
        action: "save",
        target: "scheduled_call",
      });

      if (isWeb) {
        window.open(item.page, "_blank");
      } else {
        Linking.openURL(item.page);
      }

      return;
    }

    if (isPageWithFooter(item.page)) {
      const params = isNewUser && item.name == "track" ? {} : item.params;
      controller.navigation?.jumpTo(item.page, params);
    } else {
      controller.navigate(item.page, item.params);
    }
  };

  return (
    <ScrollView style={appStyles.scrollView}>
      <Text style={styles.scoreText}>Setup {progress}% Complete!</Text>
      <View style={styles.progress}>
        <View
          style={[
            styles.complete,
            {
              width: `${progress}%`,
              backgroundColor: AppTheme.DEFAULT_COLOR,
            },
          ]}
        />
      </View>

      <View style={{ width: "100%" }}>
        {steps.map((b, index) => (
          <ChecklistItemModel key={index} item={b} goToPage={goToPage} />
        ))}
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {},
  scoreText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 8,
  },
  progress: {
    position: "relative",
    height: 4,
    width: "100%",
    backgroundColor: "#DADADA",
    borderRadius: 3,
    marginBottom: 4,
  },
  complete: {
    position: "absolute",
    left: 0,
    top: 0,
    height: 4,
    width: "100%",
    borderRadius: 3,
  },
});
